require("./tableau-2.0.0.min")

module.exports = window.tableau